import Tooltip from "@components/Tooltip";
import { useAccount } from "@contexts/AccountContext";
import { useCoins } from "@contexts/CoinsContext";
import { MsgExecuteContract } from "@goblinhunt/cosmes/client";
import useAlert from "@hooks/AlertHook";
import { useTxModal } from "@hooks/TxModalHook";
import { useWasmX } from "@hooks/WasmXHook";
import { useWallet } from "@providers/wallet.provider";
import { CollectionResponse, NftResponse } from "baaanggg";
import React from "react";
import { BidByNftResponse } from "wasmx";

type Props = {
  bidInfo: BidByNftResponse;
  collection: CollectionResponse;
  nft: NftResponse;
  onAccepted: () => void;
};

export function BidsTab({ bidInfo, collection, nft, onAccepted }: Props) {
  const { getCoin } = useCoins();
  const wasmx = useWasmX();
  const alert = useAlert();
  const txModal = useTxModal();
  const {address,wallet} = useWallet()
  const onAccept = async (buyer: string) => {
    try {
      if (!wasmx || !address)
        throw new Error(
          "Cannot load chain information, try to refresh the page"
        );

      const approveMsg = new MsgExecuteContract({
        contract: collection.nftContract,
        sender: nft.ownerAddress,
        msg: {
          approve: {
            spender: collection.collectionContract,
            token_id: nft.tokenId,
          },
        },
        funds: [],
      });

      const acceptBid = new MsgExecuteContract({
        contract: collection.collectionContract,
        sender: address,
        msg: {
          accept_bid: {
            token_id: nft.tokenId,
            buyer,
          },
        },
        funds: [],
      });

      await txModal.show(
        [approveMsg, acceptBid],
        `Accept bid NFT '${nft.name}'`,
        {
          onSuccess: async (tx) => {
            try {
              alert.loading("Sign Tx");
              await wallet!.pollTx(tx, {
                maxAttempts: 120_000,
                intervalSeconds: 15,
              });
            } catch (e) {
              // kalau mau, tampilkan warning tapi lanjut refresh
              console.warn("poll failed", e);
            }
            alert.success("Bid accepted successfully");
            onAccepted();
          },
          onError: (er) => alert.failed(er.message),
        }
      );
    } catch (e) {
      if (e instanceof Error) alert.failed(e.message);
      else console.error(e);
    }
  };

  return (
    <div
      role="table"
      className="scrollbar-custom grid max-h-72 w-full grid-cols-3 overflow-y-auto rounded-lg rounded-tl-none border border-jacarta-100 bg-white text-sm dark:border-gray-400 dark:bg-gray-900 dark:text-white"
    >
      <div className="contents" role="row">
        <div
          className="sticky top-0 bg-light-base px-4 py-2 dark:bg-jacarta-700"
          role="columnheader"
        >
          <span className="w-full overflow-hidden text-ellipsis text-jacarta-700 dark:text-jacarta-100">
            Price
          </span>
        </div>
        <div
          className="sticky top-0 bg-light-base px-4 py-2 dark:bg-jacarta-700"
          role="columnheader"
        >
          <span className="w-full overflow-hidden text-ellipsis text-jacarta-700 dark:text-jacarta-100">
            Buyer
          </span>
        </div>
        <div
          className="sticky top-0 bg-light-base px-4 py-2 dark:bg-jacarta-700"
          role="columnheader"
        >
          <span className="overflow-hidden text-ellipsis text-jacarta-700 dark:text-jacarta-100">
            Action
          </span>
        </div>
      </div>
      {bidInfo.bids.map((e) => {
        const coin = getCoin(
          e.bid_price.coin?.denom ?? e.bid_price.token?.address ?? ""
        );
        return (
          <div className="contents" role="row">
            <div
              className="flex items-center whitespace-nowrap border-t border-jacarta-100 px-4 py-4 dark:border-jacarta-600"
              role="cell"
            >
              <span className="-ml-1" data-tippy-content="ETH">
                <img
                  className={`mr-1 h-4 w-4 cursor-pointer`}
                  src={coin?.icon ?? "/src/img/coins/cw-coin.svg"}
                />
              </span>
              <span className="text-sm font-medium tracking-tight text-green">
                {Number(e.bid_price.coin?.amount ?? e.bid_price.token?.amount) /
                  Math.pow(10, coin?.decimals ?? 0)}{" "}
                {coin?.name}
              </span>
            </div>
            <div
              className="flex items-center border-t border-jacarta-100 px-4 py-4 dark:border-jacarta-600"
              role="cell"
            >
              {e.buyer.substring(0, 7)}...
              {e.buyer.substring(e.buyer.length - 5)}
            </div>
            <div
              className="flex items-center border-t border-jacarta-100 px-4 py-4 dark:border-jacarta-600"
              role="cell"
            >
              <span
                onClick={() => onAccept(e.buyer)}
                className="cursor-pointer text-accent"
              >
                Accept
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
